import { keyframes } from '@emotion/react';
import livingRoomImage from '../../../assets/home/LivingRoom.png';

const slideInFromRight = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;


export const contactUsFormStyles = (isInView) => {
  return {
    container: {
      position: 'relative',
      width: '100%',
      minHeight: '100vh',
      display: 'flex',
      overflow: 'hidden',
      backgroundColor: 'secondary.main',
    },
    headerContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      padding: {xs: "20px", lg: "35px 75px"},
      zIndex: 2,
    },
    gridContainer: {
      width: '100%',
      minHeight: {xs: '100%', lg: '100vh'},
      display: 'flex',
      alignItems: 'stretch',
    },
    leftColumn: {
      display: 'flex',
      alignItems: 'center',
      height: {xs: "unset", lg: '100%'},
      paddingBottom: {xs: '50px', lg: '0'},
      ...(isInView && {
        animation: `${slideInFromRight} 1.5s ease-out forwards`,
      }),
    },
    rightColumn: {
      minHeight: '100vh',
      alignSelf: 'stretch',
      overflow: 'hidden',
      backgroundImage: `url(${livingRoomImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
  };
};

